import { useEffect, useState } from 'react'
import { onSync, pushNow, type SyncStatus } from '../lib/sync'

/**
 * Trạng thái đồng bộ. Chỉ hiện khi có chuyện đáng nói — lúc mọi thứ bình thường
 * thì im lặng. Người bán không cần biết app đang gửi gì lên máy chủ; họ chỉ cần
 * biết khi nào có dữ liệu chưa lên.
 */
export function SyncBadge() {
  const [s, setS] = useState<SyncStatus>({ state: 'idle', pending: 0, lastSyncAt: null, lastPullAt: null })

  useEffect(() => onSync(setS), [])

  if (s.state === 'idle' && s.pending === 0) return null

  const label =
    s.state === 'offline'
      ? `Chưa có mạng${s.pending ? ` · ${s.pending} chờ gửi` : ''}`
      : s.state === 'syncing'
        ? 'Đang gửi…'
        : s.state === 'error'
          ? (s.message ?? 'Gửi lỗi')
          : `${s.pending} chờ gửi`

  return (
    <button
      type="button"
      className={`sync-badge is-${s.state}`}
      onClick={() => void pushNow()}
      title="Bấm để gửi lại ngay"
    >
      <span className="sync-dot" aria-hidden="true" />
      {label}
    </button>
  )
}
